export default "__VITE_ASSET__6a0836cf__"